export default __webpack_public_path__ + "static/media/telemarketinghelp-export.35859f6b.PNG";